import { render, staticRenderFns } from "./ModalVerEstadoSeries.vue?vue&type=template&id=79535978&"
import script from "./ModalVerEstadoSeries.vue?vue&type=script&lang=ts&"
export * from "./ModalVerEstadoSeries.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports